var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyStar = function SvgEmptyStar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 33 33",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-star"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-star)",
    stroke: "currentColor",
    d: "m17.092 25.455-.258-.156-.259.156-9.182 5.542 2.436-10.445.069-.294-.228-.198-8.113-7.028 10.682-.907.3-.025.118-.278 4.177-9.853 4.176 9.853.117.278.3.025 10.683.906-8.113 7.03-.228.197.069.294 2.436 10.445-9.182-5.542Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStar);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIGFyaWEtaGlkZGVuPSJ0cnVlIiB2aWV3Qm94PSIwIDAgMzMgMzMiPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJlbXB0eS1zdGFyIj4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iY3VycmVudENvbG9yIi8+CiAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNmZmYiLz4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPC9kZWZzPgogICAgPHBhdGggZmlsbD0idXJsKCNlbXB0eS1zdGFyKSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIGQ9Im0xNy4wOTIgMjUuNDU1LS4yNTgtLjE1Ni0uMjU5LjE1Ni05LjE4MiA1LjU0MiAyLjQzNi0xMC40NDUuMDY5LS4yOTQtLjIyOC0uMTk4LTguMTEzLTcuMDI4IDEwLjY4Mi0uOTA3LjMtLjAyNS4xMTgtLjI3OCA0LjE3Ny05Ljg1MyA0LjE3NiA5Ljg1My4xMTcuMjc4LjMuMDI1IDEwLjY4My45MDYtOC4xMTMgNy4wMy0uMjI4LjE5Ny4wNjkuMjk0IDIuNDM2IDEwLjQ0NS05LjE4Mi01LjU0MloiLz4KPC9zdmc+";